<section>
  <div class="row d-flex d-wrap w-75">
    <div class="col-12 ">
      <div class="question-type-span">
        <p><ng-component [innerHTML]="sanitizer.bypassSecurityTrustHtml(questions?.questiondescription?.description)"></ng-component></p>
        <div class="question-span" *ngFor="let o of
          questions?.prompts">
          <span class="span"><ng-component [innerHTML]="sanitizer.bypassSecurityTrustHtml(o?.promptdescription.description)"></ng-component></span>
          <div class="line"></div>
          <span class="doted-box"></span>
        </div>
        <div class="response">
          <div *ngFor="let o of
            questions.responses">
            <div class="question-btn" *ngIf="o?.responsedescription!==null">
              <button class="button"><ng-component
                  [innerHTML]="sanitizer.bypassSecurityTrustHtml(o?.responsedescription.description)"></ng-component></button>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</section>
